import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MoveIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Move",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m29.47 14.78-3.5-3.5c-.7-.7-1.75-.7-2.45 0s-.7 1.75 0 2.45l.53.53h-6.3v-6.3l.53.53c.7.7 1.75.7 2.45 0s.7-1.75 0-2.45l-3.5-3.5c-.7-.7-1.75-.7-2.45 0l-3.5 3.5c-.7.7-.7 1.75 0 2.45s1.75.7 2.45 0l.53-.53v6.3h-6.3l.52-.53c.7-.7.7-1.75 0-2.45s-1.75-.7-2.45 0l-3.5 3.5c-.7.7-.7 1.75 0 2.45l3.5 3.5c.7.7 1.75.7 2.45 0s.7-1.75 0-2.45l-.53-.52h6.3v6.3l-.53-.53c-.7-.7-1.75-.7-2.45 0s-.7 1.75 0 2.45l3.5 3.5c.7.7 1.75.7 2.45 0l3.5-3.5c.7-.7.7-1.75 0-2.45s-1.75-.7-2.45 0l-.53.53v-6.3h6.3l-.53.53c-.7.7-.7 1.75 0 2.45s1.75.7 2.45 0l3.5-3.5c.7-.7.7-1.75 0-2.45Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.87 21.85c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l4.04-4.04-4.04-4.04a1.14 1.14 0 0 1 0-1.62 1.15 1.15 0 0 1 1.62 0l4.85 4.85c.45.45.45 1.17 0 1.62l-4.85 4.85c-.22.22-.52.33-.81.33M20.71 6.99c-.29 0-.58-.11-.81-.33l-4.04-4.04-4.04 4.04c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62L15.05.19c.21-.21.51-.33.81-.33s.59.12.81.33l4.85 4.85a1.14 1.14 0 0 1-.81 1.95M15.86 31.86c-.29 0-.58-.11-.81-.33l-4.85-4.85a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l4.04 4.04 4.04-4.04a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-4.85 4.85c-.22.22-.52.33-.81.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-.63 0-1.14-.51-1.14-1.14V1A1.14 1.14 0 1 1 17 1v29.71c0 .63-.51 1.14-1.14 1.14ZM5.85 21.85c-.29 0-.58-.11-.81-.33L.19 16.67a1.14 1.14 0 0 1 0-1.62l4.85-4.85a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-4.04 4.04 4.04 4.04a1.14 1.14 0 0 1-.81 1.95"
      }), /*#__PURE__*/_jsx("path", {
        d: "M30.71 17H1a1.14 1.14 0 1 1 0-2.28h29.71a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};